import React from 'react'

export default ({
        children,
        pageClass
    }) => {
    return (
        <div className={`page ${ (pageClass) ? pageClass : '' }`}>
            {children}
        </div>
    )
}






// WEBPACK FOOTER //
// /opt/build/repo/src/components/Page.js